module.exports = __webpack_public_path__ + "media/images/top/icon/blue/ico_edit-9eabe258103aa0bbd1309af78b8cc71f.svg";